module.exports = __webpack_public_path__ + "static/media/24_B.f03c267d.png";